import AppLayout from '@/Layouts/AppLayout';
import { Card, CardContent } from '@/Components/ui/card';
import { Section, SectionHeader } from '@/Components/Section';
import { FadeIn } from '@/Components/motion';
import { Link } from 'react-router-dom';
import { Separator } from '@/Components/ui/separator';
import { siteConfig } from '@/config/site';

const sections = [
    {
        title: 'What Are Cookies',
        content:
            'Cookies are small text files that are placed on your device (computer, tablet, or mobile) when you visit a website. They are widely used to make websites work more efficiently, provide a better user experience, and supply information to website owners. Cookies can be "session" cookies, which are deleted when you close your browser, or "persistent" cookies, which remain on your device for a set period or until you delete them manually.',
    },
    {
        title: 'Types of Cookies We Use',
        content:
            `${siteConfig.brand.name} uses several types of cookies: Essential Cookies are necessary for the website to function properly, including authentication, security, and session management. Analytics Cookies help us measure and analyze website traffic and user behavior to improve our services. Functional Cookies remember your preferences and choices, such as language settings and display options. Marketing Cookies are used to track visitors across websites to display relevant advertisements and measure the effectiveness of our marketing campaigns.`,
    },
    {
        title: 'Third-Party Cookies',
        content:
            'Some cookies on our website are placed by third-party services that appear on our pages. We use third-party cookies for analytics (such as Google Analytics to understand how users interact with our site), security (to help protect against fraud and unauthorized access), and functionality (to enable features such as live chat support and social media integration). These third parties have their own privacy policies governing how they use the information collected through their cookies.',
    },
    {
        title: 'Managing Cookies',
        content:
            'You have the right to decide whether to accept or reject cookies. You can manage your cookie preferences through your browser settings. Most browsers allow you to view, delete, and block cookies from websites. Please note that if you choose to block or delete cookies, some features of our website may not function properly, and your user experience may be affected. You can also opt out of analytics cookies by using the opt-out mechanisms provided by the respective analytics services.',
    },
    {
        title: 'Updates',
        content:
            'We may update this Cookie Policy from time to time to reflect changes in technology, regulation, or our business practices. Any updates will be posted on this page with a revised "last updated" date. We encourage you to review this policy periodically to stay informed about how we use cookies.',
    },
    {
        title: 'Contact',
        content:
            'If you have any questions about our use of cookies or this Cookie Policy, please contact us at info@teffunded.com. You may also reach out through the contact page on our website for further assistance.',
    },
];

export default function CookiePolicy() {
    return (
        <AppLayout title={`Cookie Policy - ${siteConfig.brand.name}`}>
            {/* Hero */}
            <Section className="pt-32 lg:pt-40 pb-20 bg-background">
                <FadeIn>
                    <div className="text-center max-w-4xl mx-auto">
                        <p className="text-sm font-semibold uppercase tracking-widest text-muted-foreground mb-4">
                            Legal
                        </p>
                        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6">
                            Cookie{' '}
                            <span className="text-gradient">Policy</span>
                        </h1>
                        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto">
                            Learn about how {siteConfig.brand.name} uses cookies and similar
                            technologies on our platform.
                        </p>
                    </div>
                </FadeIn>
            </Section>

            {/* Content */}
            <Section className="py-16 bg-muted/30 border-t border-border">
                <FadeIn>
                    <Card className="max-w-4xl mx-auto rounded-xl border border-border bg-card/80 backdrop-blur-sm">
                        <CardContent className="p-8 md:p-12">
                            <p className="text-sm text-muted-foreground mb-10">
                                Last updated: March 2026
                            </p>

                            <div className="space-y-10">
                                {sections.map((section, index) => (
                                    <div key={section.title}>
                                        <h2 className="text-xl font-semibold text-foreground mb-3">
                                            {index + 1}. {section.title}
                                        </h2>
                                        <p className="text-muted-foreground leading-relaxed">
                                            {section.content}
                                        </p>
                                        {index < sections.length - 1 && (
                                            <Separator className="mt-10" />
                                        )}
                                    </div>
                                ))}
                            </div>
                        </CardContent>
                    </Card>
                </FadeIn>
            </Section>

            {/* Bottom spacer */}
            <Section className="py-16 bg-background border-t border-border">
                <div className="text-center max-w-2xl mx-auto">
                    <p className="text-sm text-muted-foreground">
                        Questions about cookies?{' '}
                        <Link
                            to="/contact"
                            className="text-primary hover:underline"
                        >
                            Contact us
                        </Link>
                    </p>
                </div>
            </Section>
        </AppLayout>
    );
}
